export const VerifyTypeBoolean = {
  Verified: true,
  Unverified: false,
};
